const initToggleButtons = () => {
    const btnDropDowns = document.querySelectorAll('.group-dropdown');
    if (btnDropDowns) {
      btnDropDowns.forEach((btnDropDown) => {
        btnDropDown.addEventListener('click', (event) => {
          // 1) Need to flip button direction
          const arrow = btnDropDown.querySelector('.group-dropdown-arrow');
          arrow.classList.toggle('fa-chevron-up');
          arrow.classList.toggle('fa-chevron-down');

          // 2) Need to toggle dropdown-open class
          btnDropDown.classList.toggle('dropdown-open');

          // 3) Need to display the questions
          const questions = document.querySelector(`.group-${btnDropDown.dataset.group}`);
          questions.classList.toggle("questions-open");
        });
      });
    };
}

export { initToggleButtons };
